const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/admin",
    exact: true,
    component: "Admin",
  },
];

export default routes;
